// src/hooks/useContactForm.js
// Custom hook for contact form logic (Separation of Concerns)

import { useState } from 'react';
import { validateContactForm } from '../utils/validation';
import { ContactService } from '../services/contactService';

export const useContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    businessSize: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (eventOrField, value) => {
    const isEvent = eventOrField && eventOrField.target;
    const field = isEvent ? eventOrField.target.name : eventOrField;
    const newValue = isEvent ? eventOrField.target.value : value;

    setFormData((prev) => ({
      ...prev,
      [field]: newValue,
    }));

    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: null,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    const validation = validateContactForm(formData);

    if (!validation.isValid) {
      setErrors(validation.errors);
      return;
    }

    // Submit form
    setIsSubmitting(true);
    setErrors({});

    const result = await ContactService.submitContactForm(formData);

    setIsSubmitting(false);
    setSubmitStatus(result);

    if (result.success) {
      // Reset form on success
      setFormData({
        name: '',
        email: '',
        businessSize: '',
        message: '',
      });
    }
  };

  const clearStatus = () => {
    setSubmitStatus(null);
  };

  return {
    formData,
    errors,
    isSubmitting,
    submitStatus,
    handleChange,
    handleSubmit,
    clearStatus,
  };
};
